/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { HydratedRouter } from "react-router/dom";

import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import * as Sentry from "@sentry/react-router";
import i18next from "i18next";
import { I18nextProvider, initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Fetch from "i18next-fetch-backend";
import { defaultNS, fallbackLng, supportedLngs, ns } from "./configs/i18n";

const isStaging =
  window.SENTRY_ENVIRONMENT === "staging" ||
  window.SENTRY_ENVIRONMENT === "stagingv3";
const isProd =
  window.SENTRY_ENVIRONMENT === "prod" ||
  window.SENTRY_ENVIRONMENT === "prodv3";

if (isStaging || isProd) {
  Sentry.init({
    dsn: window?.SENTRY_DSN || "",
    environment: window?.SENTRY_ENVIRONMENT || "",
    tracesSampleRate: 1,
    integrations: [
      Sentry.reactRouterTracingIntegration(),
    ],
    ...(isProd ? { release: window.SENTRY_RELEASE } : {}),
  });
}

async function main() {
  await i18next
    .use(initReactI18next)
    .use(Fetch)
    .use(LanguageDetector)
    .init({
      defaultNS,
      fallbackLng,
      supportedLngs,
      ns,
      detection: {
        order: ["htmlTag"],
        caches: [],
      },
      backend: {
        loadPath: "/api/locales?lng={{lng}}&ns={{ns}}",
      },
    });
  startTransition(() => {
    hydrateRoot(
      document,
      <I18nextProvider i18n={i18next}>
        <StrictMode>
          <HydratedRouter />
        </StrictMode>
      </I18nextProvider>,
    );
  });
}

main().catch((error) => {
  console.error(error);
  Sentry.captureException(error);
});
